// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Amount,
    AmountFromJSON,
    AmountToJSON,
    AuthorizationRequiredType,
    AuthorizationRequiredTypeFromJSON,
    AuthorizationRequiredTypeToJSON,
    ClaimEligibilityItemBeneficiary,
    ClaimEligibilityItemBeneficiaryFromJSON,
    ClaimEligibilityItemBeneficiaryToJSON,
    ClaimEligibilityItemDelivery,
    ClaimEligibilityItemDeliveryFromJSON,
    ClaimEligibilityItemDeliveryToJSON,
    CoverageLevelType,
    CoverageLevelTypeFromJSON,
    CoverageLevelTypeToJSON,
    EligibilityItemType,
    EligibilityItemTypeFromJSON,
    EligibilityItemTypeToJSON,
    InPlanNetworkType,
    InPlanNetworkTypeFromJSON,
    InPlanNetworkTypeToJSON,
    PlanType,
    PlanTypeFromJSON,
    PlanTypeToJSON,
    ProcedureCodeType,
    ProcedureCodeTypeFromJSON,
    ProcedureCodeTypeToJSON,
    QuantityType,
    QuantityTypeFromJSON,
    QuantityTypeToJSON,
    ServiceType,
    ServiceTypeFromJSON,
    ServiceTypeToJSON,
    TimePeriodType,
    TimePeriodTypeFromJSON,
    TimePeriodTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClaimEligibilityItem
 */
export interface ClaimEligibilityItem {
    /**
     * 
     * OpenAPI data type: {EligibilityItemType}
     * @type {EligibilityItemType}
     * @memberof ClaimEligibilityItem
     */
    type?: EligibilityItemType;
    /**
     * 
     * OpenAPI data type: {CoverageLevelType}
     * @type {CoverageLevelType}
     * @memberof ClaimEligibilityItem
     */
    coverageLevelType?: CoverageLevelType;
    /**
     * 
     * OpenAPI data type: {PlanType}
     * @type {PlanType}
     * @memberof ClaimEligibilityItem
     */
    planType?: PlanType;
    /**
     * Human-readable description of the coverage details
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ClaimEligibilityItem
     */
    coverageDescription?: string;
    /**
     * 
     * OpenAPI data type: {TimePeriodType}
     * @type {TimePeriodType}
     * @memberof ClaimEligibilityItem
     */
    timePeriodType?: TimePeriodType;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof ClaimEligibilityItem
     */
    benefitAmount?: Amount;
    /**
     * The benefit percentage
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ClaimEligibilityItem
     */
    benefitPercentage?: string;
    /**
     * 
     * OpenAPI data type: {QuantityType}
     * @type {QuantityType}
     * @memberof ClaimEligibilityItem
     */
    quantityType?: QuantityType;
    /**
     * The quantity amount
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ClaimEligibilityItem
     */
    quantity?: string;
    /**
     * 
     * OpenAPI data type: {AuthorizationRequiredType}
     * @type {AuthorizationRequiredType}
     * @memberof ClaimEligibilityItem
     */
    authorizationRequiredType?: AuthorizationRequiredType;
    /**
     * 
     * OpenAPI data type: {InPlanNetworkType}
     * @type {InPlanNetworkType}
     * @memberof ClaimEligibilityItem
     */
    inPlanNetworkType?: InPlanNetworkType;
    /**
     * 
     * OpenAPI data type: {ProcedureCodeType}
     * @type {ProcedureCodeType}
     * @memberof ClaimEligibilityItem
     */
    procedureCodeType?: ProcedureCodeType;
    /**
     * From procedure code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ClaimEligibilityItem
     */
    fromProcedureCode?: string;
    /**
     * From procedure code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ClaimEligibilityItem
     */
    throughProcedureCode?: string;
    /**
     * Modifier code 1
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ClaimEligibilityItem
     */
    modifierCode1?: string;
    /**
     * Modifier code 2
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ClaimEligibilityItem
     */
    modifierCode2?: string;
    /**
     * Modifier code 3
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ClaimEligibilityItem
     */
    modifierCode3?: string;
    /**
     * Modifier code 4
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ClaimEligibilityItem
     */
    modifierCode4?: string;
    /**
     * Diagnosis pointer 1
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ClaimEligibilityItem
     */
    diagnosisPointer1?: string;
    /**
     * Diagnosis pointer 2
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ClaimEligibilityItem
     */
    diagnosisPointer2?: string;
    /**
     * Diagnosis pointer 3
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ClaimEligibilityItem
     */
    diagnosisPointer3?: string;
    /**
     * Diagnosis pointer 4
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ClaimEligibilityItem
     */
    diagnosisPointer4?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ClaimEligibilityItem
     */
    eligibilityFromDate?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ClaimEligibilityItem
     */
    eligibilityThroughDate?: string;
    /**
     * Service types that fall under this benefit
     * OpenAPI data type: {array}
     * @type {Array<ServiceType>}
     * @memberof ClaimEligibilityItem
     */
    serviceTypeCodes?: Array<ServiceType>;
    /**
     * Payer messages about the benefit item
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof ClaimEligibilityItem
     */
    messages?: Array<string>;
    /**
     * Service types that fall under this benefit
     * OpenAPI data type: {array}
     * @type {Array<ClaimEligibilityItemBeneficiary>}
     * @memberof ClaimEligibilityItem
     */
    beneficiaries?: Array<ClaimEligibilityItemBeneficiary>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ClaimEligibilityItemDelivery>}
     * @memberof ClaimEligibilityItem
     */
    deliveries?: Array<ClaimEligibilityItemDelivery>;
}

export function ClaimEligibilityItemFromJSON(json: any): ClaimEligibilityItem {
    return {
            'type': !exists(json, 'type') ? undefined : EligibilityItemTypeFromJSON(json['type']),
            'coverageLevelType': !exists(json, 'coverageLevelType') ? undefined : CoverageLevelTypeFromJSON(json['coverageLevelType']),
            'planType': !exists(json, 'planType') ? undefined : PlanTypeFromJSON(json['planType']),
            'coverageDescription': !exists(json, 'coverageDescription') ? undefined : json['coverageDescription'],
            'timePeriodType': !exists(json, 'timePeriodType') ? undefined : TimePeriodTypeFromJSON(json['timePeriodType']),
            'benefitAmount': !exists(json, 'benefitAmount') ? undefined : AmountFromJSON(json['benefitAmount']),
            'benefitPercentage': !exists(json, 'benefitPercentage') ? undefined : json['benefitPercentage'],
            'quantityType': !exists(json, 'quantityType') ? undefined : QuantityTypeFromJSON(json['quantityType']),
            'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
            'authorizationRequiredType': !exists(json, 'authorizationRequiredType') ? undefined : AuthorizationRequiredTypeFromJSON(json['authorizationRequiredType']),
            'inPlanNetworkType': !exists(json, 'inPlanNetworkType') ? undefined : InPlanNetworkTypeFromJSON(json['inPlanNetworkType']),
            'procedureCodeType': !exists(json, 'procedureCodeType') ? undefined : ProcedureCodeTypeFromJSON(json['procedureCodeType']),
            'fromProcedureCode': !exists(json, 'fromProcedureCode') ? undefined : json['fromProcedureCode'],
            'throughProcedureCode': !exists(json, 'throughProcedureCode') ? undefined : json['throughProcedureCode'],
            'modifierCode1': !exists(json, 'modifierCode1') ? undefined : json['modifierCode1'],
            'modifierCode2': !exists(json, 'modifierCode2') ? undefined : json['modifierCode2'],
            'modifierCode3': !exists(json, 'modifierCode3') ? undefined : json['modifierCode3'],
            'modifierCode4': !exists(json, 'modifierCode4') ? undefined : json['modifierCode4'],
            'diagnosisPointer1': !exists(json, 'diagnosisPointer1') ? undefined : json['diagnosisPointer1'],
            'diagnosisPointer2': !exists(json, 'diagnosisPointer2') ? undefined : json['diagnosisPointer2'],
            'diagnosisPointer3': !exists(json, 'diagnosisPointer3') ? undefined : json['diagnosisPointer3'],
            'diagnosisPointer4': !exists(json, 'diagnosisPointer4') ? undefined : json['diagnosisPointer4'],
            'eligibilityFromDate': !exists(json, 'eligibilityFromDate') ? undefined : json['eligibilityFromDate'],
            'eligibilityThroughDate': !exists(json, 'eligibilityThroughDate') ? undefined : json['eligibilityThroughDate'],
            'serviceTypeCodes': !exists(json, 'serviceTypeCodes') ? undefined : (json['serviceTypeCodes'] as Array<any>).map(ServiceTypeFromJSON),
            'messages': !exists(json, 'messages') ? undefined : json['messages'],
            'beneficiaries': !exists(json, 'beneficiaries') ? undefined : (json['beneficiaries'] as Array<any>).map(ClaimEligibilityItemBeneficiaryFromJSON),
            'deliveries': !exists(json, 'deliveries') ? undefined : (json['deliveries'] as Array<any>).map(ClaimEligibilityItemDeliveryFromJSON),
    };

}

export function ClaimEligibilityItemToForm(value?: ClaimEligibilityItem): any {
    let jsonVal = ClaimEligibilityItemToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function ClaimEligibilityItemToJSON(value?: ClaimEligibilityItem): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'type': EligibilityItemTypeToJSON(value.type),
            'coverageLevelType': CoverageLevelTypeToJSON(value.coverageLevelType),
            'planType': PlanTypeToJSON(value.planType),
            'coverageDescription': cleanupBlankValuesForBackend(value.coverageDescription),
            'timePeriodType': TimePeriodTypeToJSON(value.timePeriodType),
            'benefitAmount': AmountToJSON(value.benefitAmount),
            'benefitPercentage': cleanupBlankValuesForBackend(value.benefitPercentage),
            'quantityType': QuantityTypeToJSON(value.quantityType),
            'quantity': cleanupBlankValuesForBackend(value.quantity),
            'authorizationRequiredType': AuthorizationRequiredTypeToJSON(value.authorizationRequiredType),
            'inPlanNetworkType': InPlanNetworkTypeToJSON(value.inPlanNetworkType),
            'procedureCodeType': ProcedureCodeTypeToJSON(value.procedureCodeType),
            'fromProcedureCode': cleanupBlankValuesForBackend(value.fromProcedureCode),
            'throughProcedureCode': cleanupBlankValuesForBackend(value.throughProcedureCode),
            'modifierCode1': cleanupBlankValuesForBackend(value.modifierCode1),
            'modifierCode2': cleanupBlankValuesForBackend(value.modifierCode2),
            'modifierCode3': cleanupBlankValuesForBackend(value.modifierCode3),
            'modifierCode4': cleanupBlankValuesForBackend(value.modifierCode4),
            'diagnosisPointer1': cleanupBlankValuesForBackend(value.diagnosisPointer1),
            'diagnosisPointer2': cleanupBlankValuesForBackend(value.diagnosisPointer2),
            'diagnosisPointer3': cleanupBlankValuesForBackend(value.diagnosisPointer3),
            'diagnosisPointer4': cleanupBlankValuesForBackend(value.diagnosisPointer4),
            'eligibilityFromDate': cleanupBlankValuesForBackend(value.eligibilityFromDate),
            'eligibilityThroughDate': cleanupBlankValuesForBackend(value.eligibilityThroughDate),
            'serviceTypeCodes': (value.serviceTypeCodes === undefined || value.serviceTypeCodes === null) ? undefined : (value.serviceTypeCodes as Array<any>).map(ServiceTypeToJSON),
            'messages': cleanupBlankValuesForBackend(value.messages),
            'beneficiaries': (value.beneficiaries === undefined || value.beneficiaries === null) ? undefined : (value.beneficiaries as Array<any>).map(ClaimEligibilityItemBeneficiaryToJSON),
            'deliveries': (value.deliveries === undefined || value.deliveries === null) ? undefined : (value.deliveries as Array<any>).map(ClaimEligibilityItemDeliveryToJSON),
    };
}


